import React from 'react';
import { styled } from '@mui/material/styles';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

import { PaymentMethodItem } from './PaymentMethodItem';

const StyledRadio = styled(Radio)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&.Mui-checked': {
        color: theme.palette.primary.main
    }
}));

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
    justifyContent: 'space-between',
    width: '100%',
    margin: 0
}));

export interface Option {
    label: string | React.ReactNode;
    value: any;
    onClickValue?: any;
}

interface PaymentMethodGroupProps {
    label?: string;
    value: any;
    options: Option[];
    onChange: (value: string) => void;
    onClick?: (onClickValue: any) => void;
    loading?: boolean;
}

export const PaymentMethodGroup: React.FC<React.PropsWithChildren<PaymentMethodGroupProps>> = ({
    label,
    value,
    options,
    loading,
    onChange,
    onClick
}) => {
    const handleChange = React.useCallback(
        (_event: any, newValue: string) => {
            onChange(newValue);
        },
        [onChange]
    );

    const handleClick = React.useCallback(
        (onClickValue: any) => () => onClick && onClick(onClickValue),
        [onClick]
    );
    const renderRadioButton = React.useCallback(
        (option: Option) => (
            <StyledFormControlLabel
                value={option.value}
                control={<StyledRadio />}
                labelPlacement="start"
                label={option.label}
                key={option.value}
                onClick={handleClick(option.onClickValue)}
            />
        ),
        [handleClick]
    );

    if (loading) {
        return (
            <FormControl component="fieldset" fullWidth>
                <RadioGroup name="mui-radio-group">
                    <StyledFormControlLabel
                        control={<Radio disabled />}
                        labelPlacement="start"
                        label={<PaymentMethodItem loading type="APPLEPAY" />}
                    />
                </RadioGroup>
            </FormControl>
        );
    }

    return (
        <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup name="mui-radio-group" value={value} onChange={handleChange}>
                {options.map(renderRadioButton)}
            </RadioGroup>
        </FormControl>
    );
};
